module.exports = __webpack_public_path__ + "img/27.026011d6.png";